<template>
  <div id="passenger_ship">
    <div v-if="receivedData">
      <RowCustomGraphic 
        :received-data="receivedData"
      />
    </div>  
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'CargoShip',

  data () {
    return {
      receivedData: null,
      blockId: 'passenger_turnover',
      cloneElementId: 'passenger_ship'
    }
  },

  components: {
    RowCustomGraphic: () => import('@/components/graph/RowCustomGraphic.vue'),
  },


  mounted () {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },
  
  computed: {
    ...mapGetters({
        userToken: 'getUserToken'
      }),
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '37,38').then((response) => {
        this.receivedData = {
          first: response.data[0],
          second: response.data[1]
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .traffic_road-graphics {
    display: flex;

    &-item {
      width: 50%;
    }
  }
</style>